var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:_vm.$style.container},[_c('div',{class:_vm.$style.navigation},[_c('MainHeaderNavigationBar')],1),(_vm.isSearchExpanded)?_c('div',{class:_vm.$style.searchBar},[_c('MainHeaderSearchBar')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }